import { router, currentRoute } from '@/libs/Router';
import { states, user, filters, env } from '@/stores';
import { request } from '@/helpers/request';

import { get as storageGet } from '@/helpers/storage';


let userId = user.pull('id');


function userChange() {
	const id = user.pull('id');
	// console.log('user_id: ', id);
	if (userId != id) {
		userId = id;
		filtersLoad(userId);
		//await request({ path: '/' });
		if (states.isInitialized()) {
			const currentUrn = currentRoute.pull('urn');
			//console.log('urn: ', currentUrn, userId);
			if (currentUrn) {
				if (userId) {
					const urn = router.record('onLogin', '/', true);
					router.go(urn);
				}
				else {
					router.go('/');
				}
			}
		}
	}
}


/* filtersLoad */
function filtersLoad(userId) {
	const f = storageGet(':filters:' + userId.toString());
	//console.log('userChange', f);
	//console.log(f);
	if (f) {
		env.push({ clientsFilterState: f.state });
		filters.push({ 'card': f.card, 'firm': f.firm });
	}
	else {
		env.push({ clientsFilterState: 1 });
		/*filters.push({
			'card': {
				selected: [],
				available: [],
			},
			'firm': {
				selected: [],
				available: [],
			},
		});*/
	}
}
  

export default userChange;
